require("source-map-support").install(), function (e, n) {
  "object" == typeof exports && "object" == typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define("Accordion", [], n) : "object" == typeof exports ? exports.Accordion = n() : e.Accordion = n();
}(this, function () {
  return function (e) {
    var n = {};

    function t(r) {
      if (n[r]) return n[r].exports;
      var i = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }

    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        enumerable: !0,
        get: r
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, n) {
      if (1 & n && (e = t(e)), 8 & n) return e;
      if (4 & n && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (t.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & n && "string" != typeof e) for (var i in e) {
        t.d(r, i, function (n) {
          return e[n];
        }.bind(null, i));
      }
      return r;
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, n) {
      return Object.prototype.hasOwnProperty.call(e, n);
    }, t.p = "/", t(t.s = 306);
  }({
    0: function _(e, n) {
      e.exports = require("react");
    },
    1: function _(e, n) {
      e.exports = require("prop-types");
    },
    10: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(1),
          a = t.n(o),
          c = t(2);

      function u() {
        var e = i()(["\n  align-content: ", ";\n  align-items: ", ";\n  align-self: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-direction: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n  order: ", ";\n  overflow: ", ";\n"]);
        return u = function u() {
          return e;
        }, e;
      }

      var s = t.n(c).a.div(u(), function (e) {
        return e.alignContent;
      }, function (e) {
        return e.alignItems;
      }, function (e) {
        return e.alignSelf;
      }, function (e) {
        return e.inline ? "inline-flex" : "flex";
      }, function (e) {
        return e.flexBasis;
      }, function (e) {
        return e.flexDirection;
      }, function (e) {
        return e.flexGrow;
      }, function (e) {
        return e.flexShrink;
      }, function (e) {
        return e.flexWrap ? "wrap" : "nowrap";
      }, function (e) {
        return e.justifyContent;
      }, function (e) {
        return e.order;
      }, function (e) {
        return e.overflow;
      });
      s.propTypes = {
        alignContent: a.a.string,
        alignItems: a.a.string,
        alignSelf: a.a.string,
        flexBasis: a.a.oneOfType([a.a.number, a.a.string]),
        flexDirection: a.a.string,
        flexGrow: a.a.number,
        flexShrink: a.a.number,
        flexWrap: a.a.bool,
        inline: a.a.bool,
        justifyContent: a.a.string,
        overflow: a.a.string,
        order: a.a.number
      }, s.defaultProps = {
        alignContent: "stretch",
        alignItems: "stretch",
        alignSelf: "auto",
        flexBasis: "auto",
        flexDirection: "row",
        flexGrow: 0,
        flexShrink: 1,
        flexWrap: !1,
        inline: !1,
        justifyContent: "flex-start",
        order: 0,
        overflow: "hidden"
      }, s.displayName = "FlexContainer", n.a = s;
    },
    11: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
    },
    12: function _(e, n) {
      e.exports = require("@fortawesome/react-fontawesome");
    },
    13: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(0),
          a = t.n(o),
          c = t(1),
          u = t.n(c),
          s = t(2),
          f = t.n(s),
          l = t(7);

      function p() {
        var e = i()(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
        return p = function p() {
          return e;
        }, e;
      }

      var d = f()(function (e) {
        var n = e.children,
            t = e.className;
        return a.a.Children.only(a.a.cloneElement(n, {
          className: t
        }));
      })(p(), function (e) {
        var n = e.margin;
        return Object(l.a)({
          attribute: "margin",
          value: n
        });
      }, function (e) {
        var n = e.marginTop;
        return Object(l.a)({
          attribute: "margin-top",
          value: n
        });
      }, function (e) {
        var n = e.marginBottom;
        return Object(l.a)({
          attribute: "margin-bottom",
          value: n
        });
      }, function (e) {
        var n = e.marginLeft;
        return Object(l.a)({
          attribute: "margin-left",
          value: n
        });
      }, function (e) {
        var n = e.marginRight;
        return Object(l.a)({
          attribute: "margin-right",
          value: n
        });
      });
      d.propTypes = {
        margin: u.a.oneOfType([u.a.string, u.a.number]),
        marginTop: u.a.oneOfType([u.a.string, u.a.number]),
        marginBottom: u.a.oneOfType([u.a.string, u.a.number]),
        marginLeft: u.a.oneOfType([u.a.string, u.a.number]),
        marginRight: u.a.oneOfType([u.a.string, u.a.number])
      }, n.a = d;
    },
    139: function _(e, n) {
      e.exports = require("popmotion");
    },
    140: function _(e, n) {
      e.exports = require("flubber");
    },
    15: function _(e, n, t) {
      "use strict";

      t.d(n, "g", function () {
        return r;
      }), t.d(n, "c", function () {
        return i;
      }), t.d(n, "b", function () {
        return a;
      }), t.d(n, "d", function () {
        return c;
      }), t.d(n, "a", function () {
        return o;
      }), t.d(n, "e", function () {
        return u;
      }), t.d(n, "f", function () {
        return s;
      });
      var r = 150,
          i = 250,
          o = 500,
          a = 40,
          c = "cubic-bezier(0.25, 0.01, 0.25, 1)",
          u = [.25, .01, .25, 1],
          s = 150;
    },
    16: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/getPrototypeOf");
    },
    18: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/assertThisInitialized");
    },
    19: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(1),
          a = t.n(o),
          c = t(2);

      function u() {
        var e = i()(["\n  order: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n  align-self: ", ";\n"]);
        return u = function u() {
          return e;
        }, e;
      }

      var s = t.n(c).a.div(u(), function (e) {
        return e.order;
      }, function (e) {
        return e.flexGrow;
      }, function (e) {
        return e.flexShrink;
      }, function (e) {
        return e.flexBasis;
      }, function (e) {
        return e.alignSelf;
      });
      s.propTypes = {
        order: a.a.number,
        flexGrow: a.a.number,
        flexShrink: a.a.number,
        flexBasis: a.a.oneOfType([a.a.number, a.a.string]),
        alignSelf: a.a.string
      }, s.defaultProps = {
        order: 0,
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: "auto",
        alignSelf: "auto"
      }, n.a = s;
    },
    2: function _(e, n) {
      e.exports = require("styled-components");
    },
    22: function _(e, n) {
      e.exports = require("@fortawesome/fontawesome-svg-core");
    },
    226: function _(e, n, t) {
      "use strict";

      t.r(n);
      var r = t(23),
          i = t.n(r),
          o = t(24),
          a = t.n(o),
          c = t(18),
          u = t.n(c),
          s = t(25),
          f = t.n(s),
          l = t(26),
          p = t.n(l),
          d = t(16),
          g = t.n(d),
          h = t(6),
          m = t.n(h),
          y = t(0),
          b = t.n(y),
          v = t(90),
          x = t.n(v),
          w = t(139),
          O = t(140),
          j = t(22),
          P = t(83),
          E = t(37),
          S = t(36),
          H = t(3),
          T = t.n(H),
          C = t(2),
          k = t.n(C),
          F = t(12),
          R = t(10),
          B = t(60),
          D = t(5);

      function N() {
        var e = T()(["\n\n  padding: 1px;\n"]);
        return N = function N() {
          return e;
        }, e;
      }

      function z() {
        var e = T()(["\n  font-size: 8px;\n  margin: 0;\n  padding: 1px;\n  vertical-align: 0;\n"]);
        return z = function z() {
          return e;
        }, e;
      }

      function W() {
        var e = T()(["\n  width: calc(100% - 40px);\n"]);
        return W = function W() {
          return e;
        }, e;
      }

      function q() {
        var e = T()(["\n  position: absolute;\n  right: 10px;\n"]);
        return q = function q() {
          return e;
        }, e;
      }

      function A() {
        var e = T()(["\n  margin-left: 12px;\n"]);
        return A = function A() {
          return e;
        }, e;
      }

      function I() {
        var e = T()(["\n  width: inherit;\n  height: 50px;\n  border-radius: 3px;\n  border: 1px solid ", ";\n  position: relative;\n  transition: all .15s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n    cursor: pointer;\n  }\n"]);
        return I = function I() {
          return e;
        }, e;
      }

      function G() {
        var e = T()(["\n  width: ", ";\n  margin-bottom: 10px;\n"]);
        return G = function G() {
          return e;
        }, e;
      }

      var L = k.a.div(G(), function (e) {
        return e.fullWidth ? "100%" : "400px";
      });
      L.displayName = "AccordionContainer";
      var U = k()(R.a).attrs({
        alignItems: "center"
      })(I(), function (e) {
        return e.theme.colors.grey40;
      }, Object(D.e)("grey"));
      U.displayName = "AccordionBox";
      var M = k()(B.a)(A());
      M.displayName = "StyledH5";

      var _ = k()(R.a).attrs({
        alignItems: "center"
      })(q());

      _.displayName = "ChevronContainer";
      var V = k.a.div(W());
      V.displayName = "AccordionContent";
      var X = k()(F.FontAwesomeIcon).attrs({
        icon: ["fal", "plus"],
        color: Object(D.e)("grey")
      })(z());
      X.displayName = "StyledFontAwesomeIcon";
      var Y = k.a.svg.attrs({
        color: Object(D.e)("grey"),
        width: "7px",
        height: "8px",
        viewBox: "0 0 448 512"
      })(N());
      Y.displayName = "StyledSVG";
      var J = k()(F.FontAwesomeIcon).attrs({
        style: function style(e) {
          var n = e.uistyle,
              t = e.theme.fonts;
          return {
            height: t.Body1.fontSize,
            width: t.Body1.fontSize,
            verticalAlign: "bottom",
            color: Object(D.e)(n)
          };
        }
      })({});
      J.displayName = "AccordionIcon";
      var K = t(19),
          Q = t(13);

      function Z() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }

      j.library.add(P.faChevronDown);

      var $ = "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z",
          ee = "M4.465 366.475l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L224 178.053l195.494 195.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.051c-4.686-4.686-12.284-4.686-16.971 0L4.465 349.505c-4.687 4.686-4.687 12.284 0 16.97z",
          ne = x.a.path({
        plus: {
          fill: "currentColor",
          d: $,
          transition: function transition() {
            return Object(w.tween)({
              duration: S.b
            }).pipe(Object(O.interpolate)(ee, $));
          }
        },
        chevron: {
          fill: "currentColor",
          d: ee,
          transition: function transition() {
            return Object(w.tween)({
              duration: S.b
            }).pipe(Object(O.interpolate)($, ee));
          }
        }
      }),
          te = x.a.div({
        closed: {
          height: 0,
          overflowY: "hidden",
          transition: {
            ease: S.d,
            duration: S.b
          }
        },
        open: {
          height: "auto",
          overflowY: "visible",
          transition: {
            ease: S.d,
            duration: S.b
          },
          marginTop: "10px",
          width: "100%"
        }
      }),
          re = function (e) {
        f()(r, e);
        var n,
            t = (n = r, function () {
          var e,
              t = g()(n);

          if (Z()) {
            var r = g()(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return p()(this, e);
        });

        function r() {
          var e;
          return i()(this, r), e = t.call(this), m()(u()(e), "componentDidUpdate", function (n) {
            var t = n.isNew,
                r = e.props.isNew;
            r && r !== t && e.setState(function () {
              return {
                svgPose: "plus"
              };
            });
          }), m()(u()(e), "accordionClick", function () {
            var n = e.props,
                t = n.isNew,
                r = n.onAccordionClick;
            t && (e.setState(function () {
              return {
                isTransitioning: !0,
                svgPose: "chevron"
              };
            }), e.triggerRerender()), r();
          }), m()(u()(e), "triggerRerender", function () {
            setTimeout(function () {
              e.setState(function () {
                return {
                  isTransitioning: !1
                };
              });
            }, S.b);
          }), e.state = {
            isTransitioning: !1,
            svgPose: "plus"
          }, e;
        }

        return a()(r, [{
          key: "renderActionIcon",
          value: function value() {
            var e = this.props,
                n = e.show,
                t = e.isNew,
                r = this.state,
                i = r.svgPose,
                o = r.isTransitioning,
                a = b.a.createElement(X, {
              icon: ["fal", "chevron-down"]
            });
            return (t || o) && (a = b.a.createElement(Y, null, b.a.createElement(ne, {
              pose: i
            }))), b.a.createElement(S.e, {
              rotate: n && !t && !o,
              degrees: 180,
              disableAnimation: t || o
            }, a);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                n = e.title,
                t = e.children,
                r = e.show,
                i = e.icon,
                o = e.uistyle,
                a = e.fullWidth,
                c = e.fontWeight;
            return b.a.createElement(L, {
              fullWidth: a
            }, b.a.createElement(U, {
              onClick: this.accordionClick
            }, i && i.prefix && i.name && b.a.createElement(K.a, null, b.a.createElement(Q.a, {
              marginLeft: 10
            }, b.a.createElement(J, {
              uisize: "md",
              uistyle: o,
              icon: [i.prefix, i.name],
              fixedWidth: !0
            }))), b.a.createElement(M, {
              text: n,
              uistyle: o,
              fontWeight: c
            }), b.a.createElement(_, null, this.renderActionIcon())), b.a.createElement(te, {
              pose: r ? "open" : "closed"
            }, b.a.createElement(S.a, {
              show: r
            }, b.a.createElement(E.a, {
              uistyle: "grey20",
              fitContainer: !0
            }, b.a.createElement(V, null, t)))));
          }
        }]), r;
      }(y.Component);

      re.defaultProps = {
        isNew: !1,
        show: !1,
        icon: null,
        uistyle: "brand160",
        fullWidth: !1,
        fontWeight: "600"
      };
      var ie = re;
      n.default = ie;
    },
    23: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/classCallCheck");
    },
    24: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/createClass");
    },
    25: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/inherits");
    },
    26: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/possibleConstructorReturn");
    },
    29: function _(e, n) {
      e.exports = require("react-transition-group/Transition");
    },
    3: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    306: function _(e, n, t) {
      e.exports = t(226);
    },
    35: function _(e, n) {
      e.exports = require("@fortawesome/pro-regular-svg-icons/faTimes");
    },
    36: function _(e, n, t) {
      "use strict";

      t.d(n, "a", function () {
        return r.a;
      }), t.d(n, "e", function () {
        return v;
      }), t.d(n, "b", function () {
        return p.c;
      }), t.d(n, "d", function () {
        return p.e;
      }), t.d(n, "c", function () {
        return p.d;
      });
      var r = t(44),
          i = (t(64), t(3)),
          o = t.n(i),
          a = t(0),
          c = t.n(a),
          u = t(2),
          s = t.n(u),
          f = t(29),
          l = t.n(f),
          p = t(15);

      function d() {
        var e = o()(["\n  ", "\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      function g() {
        var e = o()(["\n  ", "\n  transition: transform ", "ms;\n  transform-origin: center center;\n"]);
        return g = function g() {
          return e;
        }, e;
      }

      var h = function h(e) {
        var n = e.state,
            t = e.rotation;
        return {
          transform: "rotate(".concat("entered" === n ? t : 0, "deg)")
        };
      },
          m = s.a.div(g(), h, p.c),
          y = s.a.div(d(), h),
          b = function b(e) {
        var n = e.rotate,
            t = e.degrees,
            r = e.disableAnimation,
            i = e.children;
        return c.a.createElement(l.a, {
          in: n,
          timeout: {
            enter: 0,
            exit: p.c
          },
          enter: !1,
          exit: !1
        }, function (e) {
          return r ? c.a.createElement(y, {
            rotation: t,
            state: e
          }, i) : c.a.createElement(m, {
            rotation: t,
            state: e
          }, i);
        });
      };

      b.displayName = "RotateTransition", b.defaultProps = {
        rotate: !1,
        degrees: 0,
        disableAnimation: !1
      };
      var v = b;
      t(56), t(78), t(79);
    },
    37: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(0),
          a = t.n(o),
          c = t(2),
          u = t.n(c),
          s = t(22),
          f = t(12),
          l = t(35),
          p = t(5);

      function d() {
        var e = i()(["\n  width: ", ";\n  height: fit-content;\n  box-shadow: 0 0 4px 1px ", ",\n    0 0 4px 1px ", ";\n  border-radius: 5px;\n  box-sizing: border-box;\n  padding: ", ";\n  background: ", ";\n  position: relative;\n\n  ", "\n\n  &:hover ", " {\n    opacity: 1;\n  }\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      function g() {
        var e = i()(["\n  color: ", ";\n  font-size: ", ";\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  opacity: 0;\n  transition: opacity 0.15s ease-in-out;\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n  }\n"]);
        return g = function g() {
          return e;
        }, e;
      }

      function h() {
        var e = i()(["\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n    border-top: 1px solid ", ";\n    border-bottom: 2px solid ", ";\n  "]);
        return h = function h() {
          return e;
        }, e;
      }

      s.library.add(l.faTimes);

      var m = u()(f.FontAwesomeIcon).attrs({
        icon: ["far", "times"]
      })(g(), function (e) {
        return e.theme.colors.grey40;
      }, function (e) {
        var n = e.theme.fonts;
        return "".concat(n.Body2.fontSize, "px");
      }, function (e) {
        return e.theme.colors.grey;
      }),
          y = u.a.div(d(), function (e) {
        return e.fitContainer ? "inherit" : "fit-content";
      }, function (e) {
        return e.theme.colors.grey20;
      }, function (e) {
        return e.theme.colors.grey20;
      }, function (e) {
        return e.padding;
      }, function (e) {
        return e.theme.colors.white;
      }, function (e) {
        var n = e.theme.colors,
            t = e.uistyle,
            r = Object(p.j)(t, n);
        return Object(c.css)(h(), n.grey20, n.grey20, n.grey20, r);
      }, m),
          b = function b(e) {
        var n = e.onClose,
            t = e.children,
            r = e.uistyle,
            i = e.fitContainer,
            o = e.padding;
        return a.a.createElement(y, {
          uistyle: r,
          fitContainer: i,
          padding: o
        }, n && a.a.createElement(m, {
          onClick: n
        }), t);
      };

      b.defaultProps = {
        uistyle: "info",
        onClose: null,
        fitContainer: !1,
        padding: "20px"
      }, n.a = b;
    },
    4: function _(e) {
      e.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    42: function _(e, n, t) {
      "use strict";

      var r = t(6),
          i = t.n(r),
          o = t(11),
          a = t.n(o),
          c = t(3),
          u = t.n(c),
          s = t(0),
          f = t.n(s),
          l = t(2);

      function p(e, n) {
        var t = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          n && (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), t.push.apply(t, r);
        }

        return t;
      }

      function d() {
        var e = u()(["\n  display: block;\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      var g = t.n(l).a.div(d()),
          h = function h(e) {
        var n = e.children,
            t = e.className,
            r = a()(e, ["children", "className"]);
        return f.a.createElement(g, function (e) {
          for (var n = 1; n < arguments.length; n++) {
            var t = null != arguments[n] ? arguments[n] : {};
            n % 2 ? p(Object(t), !0).forEach(function (n) {
              i()(e, n, t[n]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : p(Object(t)).forEach(function (n) {
              Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
            });
          }

          return e;
        }({
          className: t
        }, r), n);
      };

      h.displayName = "FluidContainer", h.defaultProps = {
        className: void 0
      }, n.a = h;
    },
    44: function _(e, n, t) {
      "use strict";

      var r = t(6),
          i = t.n(r),
          o = t(0),
          a = t.n(o),
          c = t(29),
          u = t.n(c),
          s = t(15);

      function f(e, n) {
        var t = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          n && (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), t.push.apply(t, r);
        }

        return t;
      }

      function l(e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = null != arguments[n] ? arguments[n] : {};
          n % 2 ? f(Object(t), !0).forEach(function (n) {
            i()(e, n, t[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : f(Object(t)).forEach(function (n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
          });
        }

        return e;
      }

      var p = {
        transition: "opacity ".concat(s.g, "ms ease-in-out"),
        opacity: 0,
        willChange: "opacity",
        width: "inherit"
      },
          d = {
        entered: {
          opacity: 1
        },
        exiting: {
          opacity: 0
        }
      },
          g = function g(e) {
        var n = e.show,
            t = e.children;
        return a.a.createElement(u.a, {
          in: n,
          timeout: {
            enter: 0,
            exit: s.g
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (e) {
          return a.a.createElement("div", {
            style: l({}, p, {}, d[e])
          }, t);
        });
      };

      g.displayName = "FadeTransition", n.a = g;
    },
    5: function _(e, n, t) {
      "use strict";

      t.d(n, "a", function () {
        return m;
      }), t.d(n, "e", function () {
        return o;
      }), t.d(n, "j", function () {
        return a;
      }), t.d(n, "f", function () {
        return c;
      }), t.d(n, "g", function () {
        return u;
      }), t.d(n, "i", function () {
        return l;
      }), t.d(n, "c", function () {
        return p;
      }), t.d(n, "k", function () {
        return p;
      }), t.d(n, "l", function () {
        return d;
      }), t.d(n, "b", function () {
        return g;
      }), t.d(n, "d", function () {
        return h;
      }), t.d(n, "h", function () {
        return f;
      });

      var r = t(4),
          i = t(9),
          o = function o(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "primary":
            return n.brand;

          case "secondary":
          case "normal":
          default:
            return n.grey;

          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          case "brand160":
            return n.brand160;

          case "white":
            return n.white;
        }
      },
          a = function a(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "primary":
            return n.brand60;

          case "secondary":
          case "normal":
          default:
            return n.grey40;

          case "info":
            return n.infolight;

          case "support":
            return n.supportlight;

          case "success":
            return n.successlight;

          case "warning":
            return n.warninglight;

          case "alert":
            return n.alertlight;

          case "grey20":
          case "white":
            return n.grey20;
        }
      },
          c = function c(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "primary":
            return n.brand120;

          case "secondary":
          case "normal":
          default:
            return n.grey140;

          case "info":
            return n.infohover;

          case "support":
            return n.supporthover;

          case "success":
            return n.successhover;

          case "warning":
            return n.warninghover;

          case "alert":
            return n.alerthover;

          case "white":
            return n.grey20;
        }
      },
          u = function u(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i;

        switch (e) {
          case "xxs":
            return n.Body4;

          case "xs":
            return n.Body3;

          case "sm":
            return n.Body2;

          case "md":
          default:
            return n.Body1;

          case "lg":
            return n.H5;

          case "xl":
            return n.H4;

          case "xxl":
            return n.H3;

          case "xxxl":
            return n.H2;

          case "xxxxl":
            return n.H1;
        }
      },
          s = Object.freeze({
        xs: 24,
        sm: 30,
        md: 40,
        lg: 50
      }),
          f = function f(e) {
        return s[e] || s.md;
      },
          l = function l(e, n) {
        var t = {
          padding: {
            vertical: 0,
            horizontal: 10
          },
          font: {},
          supportFont: {},
          height: 0
        };

        switch (e) {
          case "xs":
            t.padding.vertical = 6, t.font = n.Body3, t.supportFont = n.Body4;
            break;

          case "sm":
            t.padding.vertical = 8, t.font = n.Body1, t.supportFont = n.Body3;
            break;

          default:
          case "md":
            t.padding.vertical = 12, t.font = n.Body1, t.supportFont = n.Body3;
            break;

          case "lg":
            t.padding.vertical = 17, t.font = n.Body1, t.supportFont = n.Body3;
        }

        return t.height = f(e), t;
      },
          p = function p(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "primary":
            return n.brand10;

          case "info":
            return n.infobackground;

          case "support":
            return n.supportbackground;

          case "success":
            return n.successbackground;

          case "warning":
            return n.warningbackground;

          case "alert":
            return n.alertbackground;

          case "normal":
          default:
            return n.white;
        }
      },
          d = function d(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "warning":
            return n.brand160;

          case "info":
          case "support":
          case "success":
          case "alert":
          default:
            return n.white;
        }
      },
          g = function g(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          default:
            return n.brand;
        }
      },
          h = function h(e) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;

        switch (e) {
          case "info":
            return n.info;

          case "support":
            return n.support;

          case "success":
            return n.success;

          case "warning":
            return n.warning;

          case "alert":
            return n.alert;

          default:
            return n.brand;
        }
      },
          m = new Map([[0, "rgb(110,73,244)"], [1, "#098256"], [2, "#7300B3"], [3, "#052066"], [4, "#6E49F4"], [5, "#0A40CC"], [6, "#FFB300"], [7, "#FF1E0E"], [8, "#038F00"], [9, "#CC34AF"], [10, "#11AEEF"], [11, "#475B68"], [12, "#DC1E7C"], [13, "#30C881"], [14, "#FF6A12"], [15, "#2D9898"]]);
    },
    56: function _(e, n, t) {
      "use strict";

      var r = t(6),
          i = t.n(r),
          o = t(0),
          a = t.n(o),
          c = t(29),
          u = t.n(c),
          s = t(15),
          f = t(42);

      function l(e, n) {
        var t = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          n && (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), t.push.apply(t, r);
        }

        return t;
      }

      function p(e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = null != arguments[n] ? arguments[n] : {};
          n % 2 ? l(Object(t), !0).forEach(function (n) {
            i()(e, n, t[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : l(Object(t)).forEach(function (n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
          });
        }

        return e;
      }

      var d = {
        transition: "opacity ".concat(s.g, "ms ease-in-out"),
        opacity: 0
      },
          g = {
        entering: {
          opacity: 0,
          position: "absolute"
        },
        entered: {
          opacity: 1,
          position: "relative"
        },
        exited: {
          opacity: 0,
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none"
        }
      },
          h = function h(e) {
        var n = e.children,
            t = e.activeIndex;
        return a.a.createElement(a.a.Fragment, null, n.map(function (e, n) {
          return a.a.createElement(u.a, {
            key: "".concat(n),
            in: n === t,
            timeout: s.g,
            appear: !0
          }, function (n) {
            return a.a.createElement(f.a, {
              style: p({}, d, {}, g[n])
            }, e);
          });
        }));
      };

      h.displayName = "SelectionFadeTransition", n.a = h;
    },
    6: function _(e, n) {
      e.exports = require("@babel/runtime/helpers/defineProperty");
    },
    60: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(1),
          a = t.n(o),
          c = t(2),
          u = t.n(c),
          s = u.a.h5.attrs({
        children: function children(e) {
          return e.children || e.text;
        }
      })({});
      s.propTypes = {
        text: a.a.string
      }, s.defaultProps = {
        text: ""
      };
      var f = s,
          l = t(5);

      function p() {
        var e = i()(["\nfont-family: ", ";\n  font-size: ", "px;\n  line-height: ", "px;\n\n  font-weight: ", ";\n  font-style: normal;\n\n  letter-spacing: normal;\n  color: ", ";\n\n  margin: 0;\n"]);
        return p = function p() {
          return e;
        }, e;
      }

      var d = u()(f)(p(), function (e) {
        return e.theme.fonts.H5.fontFamily;
      }, function (e) {
        return e.theme.fonts.H5.fontSize;
      }, function (e) {
        return e.theme.fonts.H5.lineHeight;
      }, function (e) {
        return e.fontWeight;
      }, function (e) {
        var n = e.uistyle,
            t = e.theme.colors;
        return Object(l.e)(n, t);
      });
      d.propTypes = {
        text: a.a.string,
        uistyle: a.a.oneOf(["primary", "secondary", "info", "support", "success", "warning", "alert", "brand160", "grey"]),
        fontWeight: a.a.oneOf(["normal", "600", "bold"])
      }, d.defaultProps = {
        text: "",
        uistyle: "primary",
        fontWeight: "normal"
      }, d.displayName = "H5";
      n.a = d;
    },
    64: function _(e, n, t) {
      "use strict";

      var r = t(6),
          i = t.n(r),
          o = t(0),
          a = t.n(o),
          c = t(29),
          u = t.n(c),
          s = t(15);

      function f(e, n) {
        var t = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          n && (r = r.filter(function (n) {
            return Object.getOwnPropertyDescriptor(e, n).enumerable;
          })), t.push.apply(t, r);
        }

        return t;
      }

      function l(e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = null != arguments[n] ? arguments[n] : {};
          n % 2 ? f(Object(t), !0).forEach(function (n) {
            i()(e, n, t[n]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : f(Object(t)).forEach(function (n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
          });
        }

        return e;
      }

      var p = {
        position: "absolute",
        top: "".concat(s.b, "px"),
        transition: "all ".concat(s.c, "ms cubic-bezier(0.25, 0.01, 0.25, 1)"),
        transform: "translate(0px, 0px)",
        opacity: 0,
        willChange: "transform, opacity"
      },
          d = {
        entered: {
          transform: "translate(0px, -".concat(s.b, "px)"),
          opacity: 1
        },
        exiting: {
          transform: "translate(0px, -".concat(2 * s.b, "px)"),
          opacity: 0
        }
      },
          g = function g(e) {
        var n = e.show,
            t = e.children;
        return a.a.createElement(u.a, {
          in: n,
          timeout: {
            enter: 0,
            exit: s.c
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (e) {
          return a.a.createElement("div", {
            style: l({}, p, {}, d[e])
          }, t);
        });
      };

      g.displayName = "MoveTransition", n.a = g;
    },
    7: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(2);

      function a() {
        var e = i()(["", ": ", ""]);
        return a = function a() {
          return e;
        }, e;
      }

      function c() {
        var e = i()(["", ": ", "px"]);
        return c = function c() {
          return e;
        }, e;
      }

      n.a = function (e) {
        var n = e.attribute,
            t = e.value;

        if (void 0 !== t) {
          if ("number" == typeof t) return Object(o.css)(c(), n, t);
          if ("string" == typeof t) return Object(o.css)(a(), n, t);
          throw new Error("".concat(t, " is not of valid type for ").concat(n, ".\n      prop can either number or string"));
        }
      };
    },
    78: function _(e, n, t) {
      "use strict";

      var r = t(3),
          i = t.n(r),
          o = t(0),
          a = t.n(o),
          c = t(2),
          u = t.n(c),
          s = t(29),
          f = t.n(s),
          l = t(15);

      function p() {
        var e = i()(["\n  transition: transform ", "ms ease-in-out;\n  transform-origin: ", ";\n  transform: ", ";\n  height: calc(100% + 8px);\n  width: calc(100% + 8px);\n  position: absolute;\n  top: -4px;\n  left: -4px;\n"]);
        return p = function p() {
          return e;
        }, e;
      }

      function d() {
        var e = i()(["\n  position: relative;\n"]);
        return d = function d() {
          return e;
        }, e;
      }

      var g = {
        TOP: "top",
        BOTTOM: "bottom",
        LEFT: "left",
        RIGHT: "right"
      },
          h = u.a.div(d()),
          m = u.a.div(p(), l.c, function (e) {
        return e.directionToOpen;
      }, function (e) {
        var n = e.isLeftRight,
            t = e.scaleSize;
        return n ? "scaleX(".concat(t, ")") : "scaleY(".concat(t, ")");
      }),
          y = function y(e) {
        var n = e.show,
            t = e.children,
            r = e.directionToOpen,
            i = [g.LEFT, g.RIGHT].includes(r);
        return a.a.createElement(h, null, a.a.createElement(f.a, {
          in: n,
          timeout: {
            enter: 0,
            exit: l.c
          },
          mountOnEnter: !0,
          unmountOnExit: !0
        }, function (e) {
          return a.a.createElement(m, {
            isLeftRight: i,
            scaleSize: "entered" === e ? 1 : 0,
            directionToOpen: r
          }, t);
        }));
      };

      y.displayName = "SlideTransition", y.defaultProps = {
        directionToOpen: "bottom"
      }, n.a = y;
    },
    79: function _(e, n, t) {
      "use strict";

      var r = t(23),
          i = t.n(r),
          o = t(24),
          a = t.n(o),
          c = t(18),
          u = t.n(c),
          s = t(25),
          f = t.n(s),
          l = t(26),
          p = t.n(l),
          d = t(16),
          g = t.n(d),
          h = t(6),
          m = t.n(h),
          y = t(3),
          b = t.n(y),
          v = t(0),
          x = t.n(v),
          w = t(2),
          O = t.n(w),
          j = t(15);

      function P() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }

      function E() {
        var e = b()(["\n  overflow: hidden;\n  display: block;\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n  min-height: ", "px;\n"]);
        return E = function E() {
          return e;
        }, e;
      }

      function S() {
        var e = b()(["\n  display: flex;\n  position: relative;\n  transform: ", ";\n  transition: all ", "ms ", ";\n  will-change: translateX;\n"]);
        return S = function S() {
          return e;
        }, e;
      }

      var H = O.a.div(S(), function (e) {
        var n = e.selectedPage;
        return "translateX(-".concat(100 * n, "%)");
      }, j.a, j.d),
          T = O.a.div(E(), function (e) {
        return e.minHeight;
      }),
          C = function (e) {
        f()(r, e);
        var n,
            t = (n = r, function () {
          var e,
              t = g()(n);

          if (P()) {
            var r = g()(this).constructor;
            e = Reflect.construct(t, arguments, r);
          } else e = t.apply(this, arguments);

          return p()(this, e);
        });

        function r() {
          var e;
          return i()(this, r), e = t.call(this), m()(u()(e), "adaptHeight", function () {
            var n = e.props.selectedPage,
                t = e.container.current && e.container.current.querySelector('[data-index="'.concat(n, '"]'));
            e.offsetHeight !== t.offsetHeight && (e.container.current.style.height = "".concat(t.offsetHeight, "px"), e.offsetHeight = t.offsetHeight);
          }), e.container = x.a.createRef(), e.redrawLoop = void 0, e.offsetHeight = 0, e;
        }

        return a()(r, [{
          key: "componentDidMount",
          value: function value() {
            this.props.fixedHeight || this.adaptHeight();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            var n = this.props,
                t = n.selectedPage,
                r = n.shouldTriggerRedrawLoop,
                i = n.fixedHeight,
                o = e.selectedPage,
                a = e.shouldTriggerRedrawLoop,
                c = e.fixedHeight;
            i || c || t === o && r === a || (clearInterval(this.redrawLoop), r ? this.redrawLoop = setInterval(this.adaptHeight, j.f) : this.adaptHeight());
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            clearInterval(this.redrawLoop);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
                n = e.selectedPage,
                t = e.children,
                r = e.minHeight;
            return x.a.createElement(T, {
              innerRef: this.container,
              minHeight: r
            }, x.a.createElement(H, {
              selectedPage: n
            }, t.map(function (e, n) {
              return x.a.createElement("div", {
                key: n,
                style: {
                  display: "inherit",
                  position: "relative",
                  maxWidth: "100%",
                  width: "100%",
                  flex: "1 0 auto",
                  alignItems: "flex-start",
                  height: "inherit"
                }
              }, e);
            })));
          }
        }]), r;
      }(v.Component);

      C.defaultProps = {
        shouldTriggerRedrawLoop: !1,
        fixedHeight: !1,
        minHeight: 200
      }, n.a = C;
    },
    83: function _(e, n) {
      e.exports = require("@fortawesome/pro-light-svg-icons/faChevronDown");
    },
    9: function _(e) {
      e.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    },
    90: function _(e, n) {
      e.exports = require("react-pose");
    }
  });
});